import StickyInsightsTable from "../../../components/Tables/StickyInsightsTable";
import {
  isCampaignTypeSP,
  SB_SD_OPTIMISATION_TOOLTIP,
} from "./searchTermV2LocalFilters";

export default function MasterSearchTermV2Table(props) {
  return (
    <StickyInsightsTable
      {...props}
      isRowSelectable={(row) => isCampaignTypeSP(row?.campaign_type)}
      getDisabledCheckboxTooltip={() => SB_SD_OPTIMISATION_TOOLTIP}
      getRowKey={(row, index) =>
        `${row?.search_term}-${row?.campaign_id}-${row?.ad_group_id}-${index}`
      }
      dimensionLikeKeys={["portfolio_name", "targeting", "match_type"]}
    />
  );
}
